// extracted by mini-css-extract-plugin
export default {"heading":"SectionHeading_heading__BfY8I"};